<template>
  <div>
    <div class="questionnaire-header">
      <div class="col-10">
        <div class="questionnaire-header-title">Calculs professionnels</div>
      </div>
      <div class="col-2 questionnaire-header-logo"><img src="@/assets/img/logo.png"></div>
    </div>

    <div class="questionnaire-info">
      <p>Mettez-vous dans de bonnes conditions avant de commencer le test.Une fois les {{ time }} minutes écoulées, vous ne pourrez plus accéder au test. Vous avez la possibilité de revenir sur les questions dans le temps imparti. </p>
      <p>L'usage d'une calculette est autorisé. </p>
    </div>

    <div class="questionnaire-section">
      <div class="questionnaire-section-header">
        <div class="questionnaire-section-header-main">Test de calculs professionnels</div>
        <div class="questionnaire-section-header-sub">{{ time }} minutes</div>
      </div>

      <div class="questionnaire-section-content">
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Opérations de base</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Décimaux Fractions</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Conversions</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Pourcentage Proportion</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
        <div class="questionnaire-section-content-domain">
          <div class="questionnaire-section-content-domain-name">Opérations logistiques</div>
          <div class="questionnaire-section-content-domain-time">8 questions</div>
        </div>
      </div>

      <div class="questionnaire-section-action">
        <div class="questionnaire-section-action-button">
          <button :disabled="isDisabled" class="btn btn-primary btn-block" @click="debuter">
            <span>Commencer le test</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import UserService from "@/services/user.service";
import RouteEnum from "@/router/RouteEnum";

defineProps({
  isDisabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['debuter']);

const router = useRouter();
const time = ref(45);
const domainId = 3;

const debuter = () => {
  emit('debuter', domainId);
};

onMounted(() => {
  UserService.getUserTestContent().then(
      (response) => {
        const test = response.data.calculsprofessionnels;
        const thirdTime = response.data.thirdtime;
        if (thirdTime) {
          time.value *= 1.33;
          time.value = Math.ceil(time.value);
        }
        if (test != null) router.push({name: RouteEnum.CANDIDACY_TESTS});
      }
  );
});
</script>
